import React from "react";
import { connect } from "react-redux";

import SupplierService from "services/supplier";

import ZeeTable from "components/ZeeTable";

import { update, create, remove } from "reducers/supplier";

import { setBreadcrumbs } from "reducers/view";
class Supplier extends React.Component {
  supplierService = new SupplierService();

  constructor() {
    super(...arguments);
    this.props.setBreadcrumbs([{ name: "Suppliers", slug: "/suppliers" }]);
  }

  state = {
    data: null,
  };

  columns = {
    name: { name: "Name" },
    address: {
      name: "Address",
      format: (address, row) => {
        const {
          address1,
          address2,
          address3,
          address4,
          address5,
          address6,
          address7,
          address8,
          address9,
          address10,
        } = row;

        return [
          address1,
          address2,
          address3,
          address4,
          address5,
          address6,
          address7,
          address8,
          address9,
          address10,
        ]
          .reduce((agg, item) => (item ? [...agg, item] : agg), [])
          .join(", ");
      },
    },
    country: { name: "Country" },
    telephone: { name: "Telephone" },
    email: { name: "Email" },
  };

  get data() {
    return this.props.supplier;
  }

  parseAddress(supplier) {
    if (supplier.address) {
      const address = supplier.address
        .split(",")
        .map((line) => line.trim())
        .reduce((agg, item) => (item === "" ? agg : [...agg, item]), []);

      const updated = {
        address1: null,
        address2: null,
        address3: null,
        address4: null,
        address5: null,
        address6: null,
        address7: null,
        address8: null,
        address9: null,
        address10: null,
      };

      address.forEach((item, key) => {
        updated[`address${key + 1}`] = item ?? null;
      });

      supplier = {
        ...supplier,
        ...updated,
      };
    }

    return supplier;
  }

  async onDelete(supplier) {
    const result = await this.supplierService
      .delete(supplier)
      .then(({ data }) => data);
    if (result.success) {
      this.props.remove(result.data);
      return result.data;
    }
    return false;
  }

  async onEdit(supplier) {
    supplier = this.parseAddress(supplier);

    const result = await this.supplierService
      .update(supplier)
      .then(({ data }) => data);
    if (result.success) {
      this.props.update(result.data);
      return result.data;
    }
    return false;
  }

  async onAdd(supplier) {
    supplier = this.parseAddress(supplier);

    const result = await this.supplierService
      .create(supplier)
      .then(({ data }) => data);
    if (result.success) {
      this.props.create(result.data);
      return result.data;
    }
    return false;
  }

  render() {
    return (
      <ZeeTable
        title="Supplier"
        columns={this.columns}
        data={this.data}
        hasPagination={true}
        hasSort={true}
        hasDelete={true}
        hasEdit={true}
        hasAdd={true}
        hasSearch={true}
        orderBy="name"
        onEdit={(supplier) => this.onEdit(supplier)}
        onDelete={(supplier) => this.onDelete(supplier)}
        onAdd={(supplier) => this.onAdd(supplier)}
      />
    );
  }
}

export default connect(
  (state) => {
    return {
      supplier: state.supplier.all,
    };
  },
  { update, create, remove, setBreadcrumbs }
)(Supplier);
